<h3 class="ui primary header" >{{ modal.context.title }}
	<i class="link times icon" (click)="modal.deny(undefined)"></i>
	</h3>
 <div class="content" >
       <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">
      <div *ngIf="success || error" appMargin marginY="10px">
            <esl-message-toast [(message)]="error"></esl-message-toast>
            <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
            </div>
  <div class="ui basic segment">
                           <div fxLayout="column" fxLayoutGap="25px">

                                          <div fxLayout="column">
                                                <div fxFlex><strong>Payer's Name</strong></div>
                                                <div fxFlex>{{detailPayment?.payerName}}</div>
                                          </div>

                                          <div fxLayout="column" >
                                                <div fxFlex><strong >Payer's Address </strong></div>
                                                <div fxFlex>{{detailPayment?.payerAddress}}</div>
                                          </div>


                                          <div fxLayout="column" >
                                                <div fxFlex><strong>Payer's Phone Number</strong></div>
                                                <div fxFlex>{{detailPayment?.payerPhone}}</div>
                                          </div>

                                          <div fxLayout="column" >
                                                <div fxFlex><strong>Amount Paid</strong></div>
                                                <div fxFlex>{{detailPayment?.currencyCode}} {{detailPayment?.totalAmount | number:'.2-2'}}</div>
                                          </div>

                                          <div fxLayout="column" >
                                                <div fxFlex><strong>Payer's Email </strong></div>
                                                <div fxFlex>{{detailPayment?.payerEmail}}</div>
                                          </div>

                                          <div fxLayout="column" >
                                                <div fxFlex><strong>Description </strong></div>
                                                <div fxFlex>
                                                      {{detailPayment?.description || detailPayment?.invoiceDescription}}
                                                </div>
                                          </div>

                                          <div fxLayout="column" >
                                                <div fxFlex><strong>RRR </strong></div>
                                                <div fxFlex>{{detailPayment?.gatewayTransactionRefId}}</div>
                                          </div>
                           </div>

                        </div>
 </div>
 </div>





